import React, { useState } from 'react'

//UI
import {
  Flex,
  Link,
  SimpleGrid,
  Spacer,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  Tooltip,
} from '@chakra-ui/react'

import { FileInput, Input } from '@/components/Form'

//Hooks

//Hooks

import { FileType } from '@/features/files/constants/FileType'
import VendorHistoryTable from '@/features/vendors/components/VendorHistoryTable'
import { useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

const VendorUploadTenderDocumentSection = ({ tenderDocuments, history = [], canUpload = false }) => {
  const [tenderDocumentTabIndex, setTenderDocumentTabIndex] = useState(
    canUpload ? tenderDocuments.length - 1 : tenderDocuments.length
  )
  const [vendorViewQuotationDetailModalDetail, setVendorViewQuotationDetailModalDetail] = useState({
    show: false,
    history: {},
  })
  const { t, i18n } = useTranslation()
  const vendorActionHistory = useWatch({ name: 'vendorActionHistory' }) ?? []

  return (
    <>
      <Tabs
        size="md"
        colorScheme={'teal'}
        variant="enclosed"
        index={tenderDocumentTabIndex}
        isLazy
        onChange={(index) => {
          setTenderDocumentTabIndex(index)
        }}
      >
        <TabList w="100%">
          {tenderDocuments.map((tenderDocument, tenderDocumentIndex) => {
            const displayName =
              tenderDocumentIndex === 0
                ? t('VENDOR_UPLOAD_PAGE_TENDER')
                : t('VENDOR_UPLOAD_PAGE_ADDENDUM') + tenderDocumentIndex

            return (
              <Tab
                key={'tenderDocumentTab' + tenderDocumentIndex}
                fontWeight={'bold'}
                // _hover={{ color: 'teal' }}
                as={Flex}
                gap="2"
              >
                <Tooltip label={displayName}>
                  <Text>{displayName}</Text>
                </Tooltip>
              </Tab>
            )
          })}
          <Spacer />
          <Tab fontWeight={'bold'}>
            <Tooltip label={'History'}>{t('VENDOR_UPLOAD_PAGE_HISTORY')}</Tooltip>
          </Tab>
        </TabList>
        <TabPanels>
          {tenderDocuments.map((tenderDocument, tenderDocumentIndex) => {
            return (
              <TabPanel key={'tenderDocumentTab' + tenderDocumentIndex}>
                <Flex direction={'column'} gap="2">
                  <SimpleGrid columns={2} spacing={'10px'}>
                    {tenderDocumentIndex === 0 && (
                      <>
                        <FileInput
                          name={`tenderDocuments.${tenderDocumentIndex}.annex1`}
                          label={t('VENDOR_UPLOAD_PAGE_ANNEX_1')}
                          fileType={FileType.SOURCING_ANNEX}
                          isRequired={false}
                          isRow
                          disabled
                        />
                        <FileInput
                          name={`tenderDocuments.${tenderDocumentIndex}.annex2`}
                          label={t('VENDOR_UPLOAD_PAGE_ANNEX_2')}
                          fileType={FileType.SOURCING_ANNEX}
                          isRequired={false}
                          isRow
                          disabled
                        />
                        <FileInput
                          name={`tenderDocuments.${tenderDocumentIndex}.annex3`}
                          label={t('VENDOR_UPLOAD_PAGE_ANNEX_3')}
                          fileType={FileType.SOURCING_ANNEX}
                          isRequired={false}
                          isRow
                          disabled
                        />
                        <Link href={''} textDecor={'underline'} color="blue.400" target={'_blank'}>
                          {t('VENDOR_UPLOAD_PAGE_ANNEX_4')}
                          {t('VENDOR_UPLOAD_PAGE_LINK_TO_ANNEX_4')}
                        </Link>
                      </>
                    )}

                    {Array.isArray(tenderDocument?.otherAnnexs) &&
                      tenderDocument.otherAnnexs.map((other, annexIndex) => (
                        <FileInput
                          key={annexIndex}
                          name={`tenderDocuments.${tenderDocumentIndex}.otherAnnexs.${annexIndex}.files`}
                          label={`${t('VENDOR_UPLOAD_PAGE_OTHER_ANNEX')}: ${other.name}`}
                          fileType={FileType.SOURCING_ANNEX}
                          isRequired={false}
                          isRow
                          disabled
                        />
                      ))}
                  </SimpleGrid>
                  <Input
                    label={t('VENDOR_UPLOAD_PAGE_REMARKS_FROM_SALES_OR_PROCUREMENT')}
                    name={`tenderDocuments.${tenderDocumentIndex}.remark`}
                    isRequired={false}
                    isRow
                    disabled
                  />
                </Flex>
              </TabPanel>
            )
          })}
          <TabPanel>
            <Flex my="3">
              <Text color={'blue.800'} fontWeight={'semibold'} mb="2">
                {t('VENDOR_UPLOAD_PAGE_HISTORY')}
              </Text>
            </Flex>

            <Flex overflow={'scroll'}>
              <VendorHistoryTable
                data={history}
                setVendorViewQuotationDetailModalDetail={setVendorViewQuotationDetailModalDetail}
              />
            </Flex>
          </TabPanel>
        </TabPanels>
      </Tabs>
    </>
  )
}

export default VendorUploadTenderDocumentSection
